import Vue from "vue";
import Router from "vue-router"

//import Home from '@/components/sections/Home/Home';
import Invoice20000 from '@/components/sections/Invoice/Invoice20000'
import Invoice12000 from "@/components/sections/Invoice/Invoice12000";
import Invoice8000 from "@/components/sections/Invoice/Invoice8000";
import Invoice4000 from "@/components/sections/Invoice/Invoice4000";
import Invoice2000 from "@/components/sections/Invoice/Invoice2000";
import Invoice500 from "@/components/sections/Invoice/Invoice500";

Vue.use(Router);

const url = location.pathname.split("/");
let purl = url[2];

if (purl === "undefined") {
    purl = null;
}

export default new Router({
    mode: 'history',
    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    },
    linkExactActiveClass: 'is-active',
    base: `2021/${purl}`,

    routes: [
        //{
        //    path: "/",
        //    name: 'Home',
        //    component: Home
        //},
        {
            path: "/invoice20000",
            name: 'Invoice20000',
            component: Invoice20000
        },
        {
            path: "/invoice12000",
            name: 'Invoice12000',
            component: Invoice12000
        },
        {
            path: "/invoice8000",
            name: 'Invoice8000',
            component: Invoice8000
        },
        {
            path: "/invoice4000",
            name: 'Invoice4000',
            component: Invoice4000
        },
        {
            path: "/invoice2000",
            name: 'Invoice2000',
            component: Invoice2000
        },
        {
            path: "/invoice500",
            name: 'Invoice500',
            component: Invoice500
        }
    ]
});